(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-footer-6"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFooter6(scope) {
    var toggles = (scope || document).querySelectorAll('.ss-footer-6 [data-ssf-toggle]');
    toggles.forEach(function (btn) {
      if (btn.dataset.ssfBound) return;
      btn.dataset.ssfBound = '1';
      btn.addEventListener('click', function () {
        // Only act as accordion on mobile widths
        if (window.matchMedia('(min-width: 750px)').matches) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }
  initFooter6(document);
  document.addEventListener('shopify:section:load', function (e) {
    initFooter6(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-shoppable-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.ssv add-to-cart-component').forEach(function (btn) {
      btn.setAttribute('data-add-to-cart-animation', 'false');
    });
    // variant panel toggle
    root.querySelectorAll('.ssv [data-ssv-toggle]').forEach(function (btn) {
      if (btn.dataset.b) return; btn.dataset.b = '1';
      btn.addEventListener('click', function () {
        var form = btn.closest('[data-ssv-buy]');
        var open = form.hasAttribute('data-ssv-open');
        if (open) { form.removeAttribute('data-ssv-open'); btn.setAttribute('aria-expanded', 'false'); }
        else { form.setAttribute('data-ssv-open', ''); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
    // carousel arrows
    root.querySelectorAll('.ssv').forEach(function (sec) {
      var track = sec.querySelector('[data-ssv-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-ssv-prev]');
      var next = sec.querySelector('[data-ssv-next]');
      var step = function () {
        var card = track.querySelector('.ssv__card');
        return card ? card.getBoundingClientRect().width + 16 : 300;
      };
      if (prev && !prev.dataset.b) { prev.dataset.b = '1'; prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); }
      if (next && !next.dataset.b) { next.dataset.b = '1'; next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); }
    });
    // play only visible videos (perf)
    var vids = root.querySelectorAll('.ssv__video');
    if (vids.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
